import { useState, type ImgHTMLAttributes } from 'react';

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  blurHashURL: string;
};

const ProgressiveImage = ({
  blurHashURL,
  style,
  ...otherProps
}: ImageProps) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  if (!blurHashURL) {
    return <img style={{ ...style }} {...otherProps} />;
  }

  return (
    <>
      {!isImageLoaded && (
        <img {...otherProps} style={style} src={blurHashURL} />
      )}

      <img
        onLoad={() => setIsImageLoaded(true)}
        style={{
          ...style,
          display: isImageLoaded ? 'inline' : 'none',
        }}
        {...otherProps}
      />
    </>
  );
};

export default ProgressiveImage;
